import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { MaskLine } from "./anim";
import { HERO_BG } from "@/data";

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "28%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const fade = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section id="hero" ref={ref} className="relative min-h-screen w-full overflow-hidden grain" data-testid="hero-section">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={HERO_BG} alt="" className="h-full w-full object-cover img-treatment" />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-ink/60" />
      </motion.div>

      <motion.div style={{ opacity: fade }} className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10 min-h-screen flex flex-col justify-end pb-16 md:pb-24">
        <h1 className="font-display font-light text-sand tracking-tight leading-[0.98] text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
          <MaskLine delay={0.45}>The humanity</MaskLine>
          <MaskLine delay={0.6} className="italic text-terra">beyond the mask</MaskLine>
          <MaskLine delay={0.75}>is your greatest asset.</MaskLine>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 flex flex-col md:flex-row md:items-end justify-between gap-8"
        >
          <p className="max-w-md text-muted-d text-base md:text-lg leading-relaxed">
            We help corporate teams close the gap between their professional and personal selves — creating spaces with less pretence and more presence, where people bring their true, authentic selves to work and perform at their best.
          </p>
          <button
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            className="group inline-flex items-center gap-3 self-start font-mono text-xs tracking-[0.2em] uppercase text-ink bg-sand px-7 py-4 hover:bg-terra transition-colors duration-300"
            data-testid="hero-cta"
          >
            Book a 30 minute conversation
            <ArrowDown size={15} className="group-hover:translate-y-1 transition-transform duration-300" />
          </button>
        </motion.div>
      </motion.div>
    </section>
  );
}
